import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaymentRoutingModule } from './payment-routing.module';
import { PaymentComponent } from './payment.component';
import { StepOneComponent } from './components/step-one/step-one.component';
import { StepTwoComponent } from './components/step-two/step-two.component';
import { LayoutModule } from '../layout/layout.module';

import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { PlanSideComponent } from './components/plan-side/plan-side.component';
import { ReservationHeaderComponent } from './components/reservation-header/reservation-header.component';
import { 
  MatExpansionModule, 
  MatButtonModule,
  MatCheckboxModule
} from '@angular/material';
library.add(fab, fas, far)

@NgModule({
  imports: [
    CommonModule,
    PaymentRoutingModule,
    LayoutModule,
    MatExpansionModule,
    MatButtonModule,
    MatCheckboxModule
  ],
  declarations: [PaymentComponent, StepOneComponent, StepTwoComponent, PlanSideComponent, ReservationHeaderComponent]
})
export class PaymentModule { }
